import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './Pages/Home';
import About from './Pages/About';
import Services from './Pages/Service';
import ERP from './Pages/ERP';
import Contact from './Pages/Contact';
import Blog from './Pages/Blog';
import Solutions from './Pages/Solutions';
import ScrollToTop from "./Components/ScrollToTop";
import WhatsAppButton from './Components/WhatsAppButton';

import './index.css';

function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/erp-services" element={<ERP />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/solutions" element={<Solutions />} />
        </Routes>
        <WhatsAppButton />
      </Router>
    </div>
  );
}

export default App;